import React, { createContext, useState } from "react";

export const NavbarContext = createContext<any>(undefined);

export const NavbarProvider: React.FC<any> = ({ children }) => {
  const [header, setHeader] = useState<boolean>(true);
  const [special, setSpecial] = useState<boolean>(true);

  const changeSpecialTrue = () => {
    setSpecial(true);
  };

  const changeSpecialFalse = () => {
    setSpecial(false);
  };

  const changeHeaderTrue = () => {
    setHeader(true);
  };

  const changeHeaderFalse = () => {
    setHeader(false);
  };

  const contextValue = {
    header,
    special,
    changeHeaderFalse,
    changeHeaderTrue,
    changeSpecialFalse,
    changeSpecialTrue,
  };

  return (
    <NavbarContext.Provider value={contextValue}>
      {children}
    </NavbarContext.Provider>
  );
};
